module.exports = "/_next/static/images/no-b884cec9fb2d4762a79626f841796979.svg";